import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Chat,ChatData } from '../data/chat';
import { MessageHandlerService } from "../../services/message-handler.service"
import { EventEmitter } from '@angular/core';

@Injectable()
export class ChatService extends ChatData {

  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiChat: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  async deleteChat(id?) {
    try {
      let flyers = await this.http.delete(this.api + "chat/" + (id || "")).toPromise();
      return flyers
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async createChat(data) {
    try {

      let response = await this.http.post(this.api + "chat", data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getChats(pagination, filter, order) {
    console.log({ pagination, filter, order });
    try {
      let response = await this.http.post(this.api + "chats", { pagination, filter, order }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getChat(id: string) {
    try {

      let chat = <Chat>await this.http.get(this.api + "chat/" + id).toPromise();
      return chat

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async duplicateChat(id: string) {
    try {

      let chat = <Chat>await this.http.get(this.api + "chat/duplicate/" + id).toPromise();
      return chat

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async editChat(data, id?: string) {
    try {

      let response = <Chat>await this.http.put(this.api + "chat/" + (id || ''), data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

}
